module.exports = __webpack_public_path__ + "files/a4c7059e77b88a9a3b13f56e7c06fc5f.png";